module.exports = __webpack_public_path__ + "example_portfolios1.svg?b74adbb64e4bab72bcc802c53eceba01";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/portfoliomanager/example_portfolios1.svg
// module id = 337
// module chunks = 0